import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {AssignAccountsEntitlementsResultModal} from './assign-accounts-entitlements.result.modal';
import {
    clearResult,
    selectAssignAccountsEntitlementsBulkUuid,
    selectAssignAccountsEntitlementsShown,
    selectAssignAccountsEntitlementsTask,
} from './assign-accounts-entitlements.slice';


export const AssignAccountsEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectAssignAccountsEntitlementsBulkUuid}
        actionTaskSelector={selectAssignAccountsEntitlementsTask}
        actionShownSelector={selectAssignAccountsEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <AssignAccountsEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
